(ns manatee.admin.task-config.documents.app-db
  "Task documents app. db.")

;; Data Paths

(def ^:private root-path
  [:task-documents])

(def ^:private document-upload-payload-path
  (conj root-path :upload-payload))

(def ^:private document-upload-name-path
  (conj document-upload-payload-path :name))

(def ^:private document-upload-file-path
  (conj document-upload-payload-path :file))

(def ^:private documentation-link-upload-payload-path
  (conj root-path :link-upload-payload))

(def ^:private documentation-link-upload-name-path
  (conj documentation-link-upload-payload-path :name))

(def ^:private documentation-link-upload-file-path
  (conj documentation-link-upload-payload-path :link))

(def ^:private uploading?-path
  (conj root-path :uploading?))

(def ^:private link-uploading?-path
  (conj root-path :link-uploading?))

(def ^:private documents-path
  (conj root-path :documents))

;; Reset

(defn reset
  [db]
  (assoc-in db root-path nil))

;; Document Upload Form Payload

(defn get-document-upload-payload
  [db]
  (get-in db document-upload-payload-path))

(defn set-document-upload-name
  [db name]
  (assoc-in db document-upload-name-path name))

(defn set-document-upload-file
  [db file]
  (assoc-in db document-upload-file-path file))

(defn set-uploading?
  [db uploading?]
  (assoc-in db uploading?-path uploading?))

(defn uploading?
  [db]
  (get-in db uploading?-path))

(defn clear-document-upload-payload
  [db]
  (-> db
      (set-document-upload-name nil)
      (set-document-upload-file nil)))

;; Documentation Link Upload Form Payload

(defn get-documentation-link-upload-payload
  [db]
  (get-in db documentation-link-upload-payload-path))

(defn set-documentation-link-upload-name
  [db name]
  (assoc-in db documentation-link-upload-name-path name))

(defn set-documentation-link-upload-link
  [db link]
  (assoc-in db documentation-link-upload-file-path link))

(defn set-link-uploading?
  [db uploading?]
  (assoc-in db link-uploading?-path uploading?))

(defn link-uploading?
  [db]
  (get-in db link-uploading?-path))

(defn clear-documentation-link-upload-payload
  [db]
  (-> db
      (set-documentation-link-upload-name nil)
      (set-documentation-link-upload-link nil)))

;; Current Documents

(defn set-documents
  [db documents]
  (assoc-in db documents-path documents))

(defn get-documents
  [db]
  (get-in db documents-path))
